import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { E_ENABLED_STATUS } from './CommonOptionsService.type';
let CommonOptionsService = class CommonOptionsService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    /**
     * 状态：$t('backoffice.common.enabledOfTrue') 失效
     */
    get StatusOptions() {
        return [
            { text: this.i18n.t('backoffice.common.enabledOfTrue'), value: E_ENABLED_STATUS.ACTIVE },
            { text: this.i18n.t('backoffice.common.enabledOfFalse'), value: E_ENABLED_STATUS.INACTIVE }
        ];
    }
    getStatus(status) {
        return this.StatusOptions.find(item => item.value === status)?.text;
    }
    getStatusBadgeVariant(status) {
        const badgeVariant = {
            [E_ENABLED_STATUS.ACTIVE]: 'success',
            [E_ENABLED_STATUS.INACTIVE]: 'warning',
        };
        return badgeVariant[status];
    }
};
CommonOptionsService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], CommonOptionsService);
export { CommonOptionsService };
